module.exports = __webpack_public_path__ + "img/mac-pro.ab7bc8ec.svg";